export default "__VITE_ASSET__9gBJu43S__"